
<style scoped lang="scss">
@import '~@/assets/styles/theme';
@import '~@/assets/styles/vars';

.user-option_wrapper {
  @extend .t-moon;
  font-family: $ff_basic;
  margin: 0 auto;

  select {
    border: none;
    option {
      @extend .t-moon--skelton-h;
    }
  }
  .user-option_table {
    font-size: 1.4rem;
    width: 100%;
    tr {}
    td {
      padding: 10px;
      &.heading {
        text-align: left;
        // width: 30%;
        // font-size: 1.4rem;
      }
      &.content {
      }
      div {
        display: inline-block;
      }
    }

    .input-number {
      font-family: $ff_basic;
      width: 60px;
      text-align: center;
      background-color: transparent;
      // border: none;
      // border-width: 0 0 2px 0;
    }
  }
}
</style>

<template lang="pug">
.user-option_wrapper
  table.user-option_table
    tr
      td.heading NOTE-SPEED
      td.content
        numberVariator(
          :value="userSpeed"
          :step="0.5"
          buttonCssClass="t-lightgreen"
          @change="onChangeNoteSpeed"
        )
    tr
      td.heading TIMING(msec)
      td.content
        input-range(
          :step="1"
          :rangeMin="-USER_TIMING_RANGE"
          :rangeMax="USER_TIMING_RANGE"
          :value="userTiming"
          @change="onChangeTiming"
        )
    tr
      td.heading SE
      td.content
        select(@change="onChangeSoundTheme")
          option(
            v-for="(item, index) in soundThemes"
            :value="item.key"
            :selected="currentSoundTheme === item.key"
          ) {{item.label}}
    tr
      td.heading SKIN
      td.content
        select(@change="onChangeSkinTheme")
          option(
            v-for="(item, index) in skinTypes"
            :value="item.key"
            :selected="currentSkinName === item.key"
          ) {{item.label}}
    tr
      td.heading LITE MODE
      td.content
        switch-button(:isActive="liteMode" @click="toggleLiteMode")
    tr
      td.heading AUTO PLAY
      td.content
        switch-button(:isActive="autoPlay" @click="toggleAutoPlay")
    tr
      td.heading DEBUG MODE
      td.content
        switch-button(:isActive="debugMode" @click="toggleDebugMode")
</template>

<script>
const pxb = window.pxb;
import inputRange from '@/components/sub/inputRange';
import switchButton from '@/components/sub/SwitchButton';
import numberVariator from '@/components/sub/NumberVariator';
import LStore from 'store/dist/store.modern';
import {USER_DATA_STORE_KEY} from '@/Const';

/* load user option data from localStorage */
let userData = LStore.get(USER_DATA_STORE_KEY) || {};
Object.defineProperty(userData, 'save', {
  value: function(prop, value) {
    this[prop] = value;
    LStore.set(USER_DATA_STORE_KEY, this);
  },
});
/* set to pxb-core */
Object.keys(userData).forEach((prop)=> {
  if (userData[prop] && pxb.GameManager.hasOwnProperty(prop))
    pxb.GameManager[prop] = userData[prop];
});
/* Debug: key command to reset to default */
document.addEventListener('keydown', (e)=> {
  let kc = e.keyCode;
  /* shift + ctrl + alt + l(76) */
  if (e.shiftKey && e.ctrlKey && e.ctrlKey && kc === 76) {
    LStore.set(USER_DATA_STORE_KEY, {});
    console.log('USER DATA clear');
  }
}, false);
// console.log(userData);

export default {
  name: 'userOptionForm',
  components: {
    inputRange,
    switchButton,
    numberVariator,
  },
  data () {
    return {
      USER_TIMING_RANGE: 200,
      soundThemes: [].concat(pxb.SOUND_THEMES),
      skinTypes: [].concat(pxb.SKINS),
      currentSoundTheme: pxb.GameManager.soundTheme,
      currentSkinName: pxb.GameManager.skinName,
      userSpeed: pxb.GameManager.userSpeed || 0,
      userTiming: pxb.GameManager.userTiming || 0,
      liteMode: pxb.GameManager.liteMode || false,
      debugMode: pxb.GameManager.debugMode || false,
      autoPlay: pxb.GameManager.autoPlay || false,
    }
  },

  methods: {
    onChangeNoteSpeed (newVal) {
      pxb.GameManager.userSpeed = this.userSpeed = Number(newVal);
      userData.save('userSpeed', pxb.GameManager.userSpeed);
    },
    onChangeTiming (newVal) {
      pxb.GameManager.userTiming = this.userTiming = Number(newVal);
      userData.save('userTiming', pxb.GameManager.userTiming);
    },
    onChangeSoundTheme (e) {
      const val = String(e.target.value);
      this.currentSoundTheme = pxb.GameManager.soundTheme = val;
      userData.save('soundTheme', pxb.GameManager.soundTheme);
    },
    onChangeSkinTheme (e) {
      const val = String(e.target.value);
      this.currentSkinName = pxb.GameManager.skinName = val;
      userData.save('skinName', pxb.GameManager.skinName);
    },
    toggleLiteMode() {
      this.liteMode = !this.liteMode;
      pxb.GameManager.liteMode = this.liteMode;
      userData.save('liteMode', pxb.GameManager.liteMode);
    },
    toggleAutoPlay() {
      this.autoPlay = !this.autoPlay;
      pxb.GameManager.autoPlay = this.autoPlay;
      userData.save('autoPlay', pxb.GameManager.autoPlay);
    },
    toggleDebugMode() {
      this.debugMode = !this.debugMode;
      pxb.GameManager.debugMode = this.debugMode;
      userData.save('debugMode', pxb.GameManager.debugMode);
    },
  },

  created () {
    /* pxb側で変化したときに値が取れないのでphina.$watchで監視 */
    pxb.GameManager.$watch('userSpeed', (newVal, oldVal)=> {
      if (newVal !== oldVal) this.userSpeed = newVal;
    });
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserOptionForm.vue